import {
  apiSubmitContribution,
  apiSubmitContributionWithAttachment,
  apiMarkContributionAsConclusion,
  apiUnmarkContributionAsConclusion,
  apiDeleteContribution,
  apiEditContribution,
  apiSubmitContributionReply
} from '../../common/api/discussion'
import { apiGetAssessmentFile } from '../../common/api/assessment'

const fetchDiscussion = assessmentFileId => ({
  requestPrefix: 'DISCUSSION:FETCH',
  params: { assessmentFileId },
  request: () =>
    apiGetAssessmentFile(assessmentFileId, {
      include:
        'assessment_file.actions,assessment_file.action.action_object,assessment_file.action.action_object.details,assessment_file.action.action_object.timestamps,assessment_file.action.details,assessment_file.action.originator,assessment_file.action.account.names,assessment_file.action.account.la_manager_type,assessment_file.action.account.la_manager_type.school_organisation,assessment_file.action.account.la_manager_type.school_organisation.details,assessment_file.action.account.avatar,assessment_file.action.action_object.guest_moderator,assessment_file.action.action_object.account.email_identity.email,assessment_file.action.action_object.account,assessment_file.action.action_object.account.names,assessment_file.action.action_object.marked_as_conclusion_by.names,assessment_file.action.timestamps,assessment_file.action.action_object.attachment,assessment_file.action.action_object.attachment.file,assessment_file.action.action_object.policy,assessment_file.action.action_object.works,assessment_file.action.action_object.replies,assessment_file.action.action_object.reply.actions,assessment_file.action.action_object.reply.action.action_object,assessment_file.action.action_object.reply.action.action_object.details,assessment_file.action.action_object.reply.action.action_object.timestamps,assessment_file.action.action_object.reply.action.action_object.originator,assessment_file.action.action_object.reply.action.action_object.account.names,assessment_file.action.action_object.reply.action.action_object.account.avatar,assessment_file.action.action_object.reply.action.action_object.policy'
    })
})

const openSidebar = () => {
  return {
    type: 'DISCUSSION:SIDEBAR:OPEN'
  }
}

const closeSidebar = () => ({
  type: 'DISCUSSION:SIDEBAR:CLOSE'
})

const submitContribution = (id, currentConclusion, data) => ({
  requestPrefix: 'DISCUSSION:SUBMIT',
  params: { currentConclusion },
  request: () => {
    const include =
      'action.details,action.timestamps,action.action_object,action.action_object.details,action.action_object.timestamps,action.originator,action.account.names,action.account.avatar,action.action_object.marked_as_conclusion_by.names,action.action_object.attachment,action.action_object.attachment.file,action.action_object.policy,action.action_object.works,action.action_object.replies'
    return data.file
      ? apiSubmitContributionWithAttachment(id, data, { include })
      : apiSubmitContribution(id, data, { include })
  }
})

const submitContributionReply = (assessmentFileId, parentId, data, id) => ({
  requestPrefix: 'DISCUSSION:SUBMIT_REPLY',
  params: { assessmentFileId, parentId, id },
  request: () => {
    const include =
      'action.details,action.timestamps,action.action_object,action.action_object.details,action.action_object.timestamps,action.originator,action.account.names,action.account.avatar,action.action_object.marked_as_conclusion_by.names,action.action_object.attachment,action.action_object.attachment.file,action.action_object.policy,action.action_object.works,action.action_object.account,action.action_object.account.names'
    return apiSubmitContributionReply(assessmentFileId, parentId, data, {
      include
    })
  }
})

const markAsConclusion = (contributionId, actionId) => ({
  requestPrefix: 'DISCUSSION:MARK_AS_CONCLUSION',
  params: { actionId },
  request: () =>
    apiMarkContributionAsConclusion(contributionId, {
      include:
        'action.details,action.timestamps,action.action_object,action.action_object.details,action.action_object.timestamps,action.originator,action.account.names,action.account.avatar,action.action_object.marked_as_conclusion_by.names'
    })
})

const unmarkAsConclusion = (contributionId, actionId) => ({
  requestPrefix: 'DISCUSSION:UNMARK_AS_CONCLUSION',
  params: { actionId },
  request: () =>
    apiUnmarkContributionAsConclusion(contributionId, {
      include:
        'action.details,action.timestamps,action.action_object,action.action_object.details,action.action_object.timestamps,action.originator,action.account.names,action.account.avatar'
    })
})

const deleteContribution = (contributionId, actionId) => ({
  requestPrefix: 'DISCUSSION:DELETE',
  params: { contributionId, actionId },
  request: () => apiDeleteContribution(contributionId)
})

const deleteContributionReply = (contributionId, actionId, parentId) => ({
  requestPrefix: 'DISCUSSION:DELETE_REPLY',
  params: { contributionId, actionId, parentId },
  request: () => apiDeleteContribution(contributionId)
})

const editContribution = (contributionId, actionId, body) => ({
  requestPrefix: 'DISCUSSION:EDIT',
  params: { contributionId, actionId, body },
  request: () =>
    apiEditContribution(contributionId, body, {
      include:
        'action.details,action.timestamps,action.action_object,action.action_object.details,action.action_object.timestamps,action.originator,action.account.names,action.account.avatar,action.action_object.marked_as_conclusion_by.names,action.action_object.attachment,action.action_object.attachment.file,action.action_object.policy'
    })
})

const editContributionReply = (contributionId, actionId, body, parentId) => ({
  requestPrefix: 'DISCUSSION:EDIT_REPLY',
  params: { contributionId, actionId, body, parentId },
  request: () =>
    apiEditContribution(contributionId, body, {
      include:
        'action.details,action.timestamps,action.action_object,action.action_object.details,action.action_object.timestamps,action.originator,action.account.names,action.account.avatar,action.action_object.marked_as_conclusion_by.names,action.action_object.attachment,action.action_object.attachment.file,action.action_object.policy'
    })
})

const openEditContributionDialog = (id, contributionId, body, parentId) => ({
  type: 'DISCUSSION:EDIT_CONTRIBUTION_DIALOG:OPEN',
  params: {
    id,
    contributionId,
    body,
    parentId
  }
})

const closeEditContributionDialog = () => ({
  type: 'DISCUSSION:EDIT_CONTRIBUTION_DIALOG:CLOSE'
})

const showTemplates = () => ({
  type: 'DISCUSSION:TEMPLATES:SHOW'
})

const hideTemplates = () => ({
  type: 'DISCUSSION:TEMPLATES:HIDE'
})

const showWorks = () => ({
  type: 'DISCUSSION:WORKS:SHOW'
})

const hideWorks = () => ({
  type: 'DISCUSSION:WORKS:HIDE'
})

export {
  fetchDiscussion,
  openSidebar,
  closeSidebar,
  submitContribution,
  markAsConclusion,
  unmarkAsConclusion,
  deleteContribution,
  editContribution,
  openEditContributionDialog,
  closeEditContributionDialog,
  showTemplates,
  hideTemplates,
  showWorks,
  hideWorks,
  submitContributionReply,
  editContributionReply,
  deleteContributionReply
}
